import React, { FC, PropsWithChildren } from 'react';
import { FlexStyle, StyleSheet, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

interface RowProps extends FlexStyle {
  style?: ViewStyle;
}

const StyledRow = styled.View`
  flex-direction: row;
`;

const Row: FC<PropsWithChildren<RowProps>> = ({
  style,
  children,
  ...flexStyles
}) => {
  const computedStyles = StyleSheet.compose(style, flexStyles);

  return <StyledRow style={computedStyles}>{children}</StyledRow>;
};

export default Row;
